module.exports = __webpack_public_path__ + "static/media/Group 3186.8178f921.png";